define('modules/form_editor/views/preview_custom_linlogin',['require','exports','module','./preview_base','../../editor/models/editorstate','ldsh!../templates/preview_custom_linlogin_amp','ldsh!../templates/preview_custom_linlogin'],function(require, exports, module){
    "use strict";
    var PreviewBase = require("./preview_base"),
        EditorState = require("../../editor/models/editorstate");

    module.exports = PreviewBase.extend({
        template: null,
        initialize: function(options){
            this.template = EditorState.getAMPState() ?
                require("ldsh!../templates/preview_custom_linlogin_amp"): require("ldsh!../templates/preview_custom_linlogin");
            module.exports.__super__.initialize.apply(this, arguments);
        },
    });
});

